// src/areas/adminAreaApi.ts
import { apiClient } from "@maat/api-base";
var adminAreaApi = {
  // ── Areas ──────────────────────────────────────────────────────────────
  listAreas: async (search) => {
    return apiClient.get("/main/api/admin/areas", { params: search ? { search } : void 0 });
  },
  createArea: async (data) => {
    return apiClient.post("/main/api/admin/areas", data);
  },
  updateArea: async (id, data) => {
    return apiClient.patch(`/main/api/admin/areas/${id}`, data);
  },
  deleteArea: async (id) => {
    await apiClient.delete(`/main/api/admin/areas/${id}`);
  },
  reconcileProperties: async (areaId) => {
    return apiClient.post(`/main/api/admin/areas/${areaId}/reconcile`);
  },
  listAreaTypes: async () => {
    return apiClient.get("/main/api/admin/area-types");
  },
  // ── Attractions (per area) ─────────────────────────────────────────────
  populateAttractions: async (areaId) => {
    return apiClient.post(`/main/api/admin/areas/${areaId}/attractions/populate`);
  },
  listAttractions: async (areaId, params) => {
    return apiClient.get(`/main/api/admin/areas/${areaId}/attractions`, { params });
  },
  addAttraction: async (areaId, data) => {
    return apiClient.post(`/main/api/admin/areas/${areaId}/attractions`, data);
  },
  searchPlaces: async (areaId, query) => {
    return apiClient.get(`/main/api/admin/areas/${areaId}/places/search`, {
      params: { query }
    });
  },
  setAttractionHidden: async (id, isHidden) => {
    return apiClient.patch(`/main/api/admin/attractions/${id}`, { is_hidden: isHidden });
  }
};

export {
  adminAreaApi
};
